import Vue from 'vue';

Vue.component('homepage-showcase-slider', {
    props: {
        cars: {
            type: Array,
        },
    },
    data() {
        return {
            tabIndex: 999,
            homepageCars: null,
            allCars: null,
            activeTooltipIndex: null,
        };
    },

    created() {
        this.allCars = this.cars.sort((a, b) => a.orderNumber - b.orderNumber);
    },

    computed: {
        isLoading: function () {
            return !Boolean(this.homepageCars);
        },
    },

    watch: {
        allCars: function (val) {
            this.homepageCars = val;
        },
    },

    mounted() {
        window.addEventListener('click', this.handleTooltipOutsideClick);
    },

    destroyed() {
        window.removeEventListener('click', this.handleTooltipOutsideClick);
    },

    methods: {
        parseTransformedImage(image) {
            return JSON.parse(image);
        },

        handleShowInternalImageWithLink(car) {
            return (
                car.internalLinkUrl &&
                car.isImageInternalOrProduct === 'internal'
            );
        },

        handleShowProductImageWithLink(car) {
            return car.productUrl && car.isImageInternalOrProduct === 'product';
        },

        switchTab(index, typeFilter) {
            if (index !== 999) {
                this.tabIndex = index;
            }
            if (typeFilter === 'all') {
                this.tabIndex = 999;
                this.homepageCars = this.allCars;
                return;
            }
            this.homepageCars = this.allCars.filter((item) => {
                return item.carType === typeFilter;
            });
        },

        handleTabKeyDown(event, index, typeFilter) {
            // Handle arrow key navigation for tab list
            const tablistItems = this.$el.querySelectorAll('[role="tab"]');
            const currentTabIndex = Array.from(tablistItems).findIndex(
                (tab) => tab === document.activeElement,
            );

            let nextTabIndex;

            switch (event.key) {
                case 'ArrowLeft':
                case 'ArrowUp':
                    event.preventDefault();
                    // Navigate to previous tab, or wrap to end if at first tab
                    nextTabIndex =
                        currentTabIndex > 0
                            ? currentTabIndex - 1
                            : tablistItems.length - 1;
                    this.focusTab(tablistItems[nextTabIndex]);
                    break;

                case 'ArrowRight':
                case 'ArrowDown':
                    event.preventDefault();
                    // Navigate to next tab, or wrap to beginning if at last tab
                    nextTabIndex =
                        currentTabIndex < tablistItems.length - 1
                            ? currentTabIndex + 1
                            : 0;
                    this.focusTab(tablistItems[nextTabIndex]);
                    break;

                case 'Home':
                    event.preventDefault();
                    // Navigate to first tab
                    this.focusTab(tablistItems[0]);
                    break;

                case 'End':
                    event.preventDefault();
                    // Navigate to last tab
                    this.focusTab(tablistItems[tablistItems.length - 1]);
                    break;

                case 'Enter':
                case ' ':
                    event.preventDefault();
                    // Activate current tab when Enter or Space is pressed
                    this.switchTab(index, typeFilter);
                    break;
            }
        },

        focusTab(tabElement) {
            // Update tabindex attributes to enable proper keyboard navigation
            const allTabs = this.$el.querySelectorAll('[role="tab"]');
            allTabs.forEach((tab) => {
                tab.setAttribute('tabindex', '-1');
            });

            // Only move focus to the tab without activating it
            tabElement.setAttribute('tabindex', '0');
            tabElement.focus();
        },

        focusAndActivateTab(tabElement) {
            // Extract index and typeFilter from element
            if (tabElement.id === 'tab-all') {
                this.switchTab(999, 'all');
            } else {
                const tabIndex = parseInt(
                    tabElement.id.replace('tab-', ''),
                    10,
                );
                const typeFilter = tabElement.dataset.typeFilter;
                this.switchTab(tabIndex, typeFilter);
            }
            tabElement.focus();
        },

        getCurrentTabId() {
            return this.tabIndex === 999 ? 'tab-all' : `tab-${this.tabIndex}`;
        },

        setAllModels() {
            if (this.tabIndex !== 999) {
                this.tabIndex = 999;
            }
            setTimeout(() => this.draggable(), [500]);
        },

        handleCarshowcaseTabActive(index) {
            return index === this.tabIndex
                ? 'carshowcase__tab-title--active'
                : '';
        },

        handleCarTypeColor(typeColor) {
            return `color: ${typeColor}`;
        },

        handleTooltipOutsideClick(event) {
            const tooltip = document.getElementById(
                `tooltip-${this.activeTooltipIndex}`,
            );
            if (!tooltip) return;

            const isClickInsideTooltip = tooltip.contains(event.target);
            const isTooltipActive = typeof this.activeTooltipIndex === 'number';
            if (!isClickInsideTooltip && isTooltipActive) {
                this.activeTooltipIndex = null;
            }
        },

        toggleTooltip(index) {
            if (this.activeTooltipIndex === index) {
                this.activeTooltipIndex = null;
                return;
            }

            this.activeTooltipIndex = index;
        },
    },
});
